import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { formService } from '../../services/formServices'
import { handleApiError } from '../../utils/handleApiError.js'

export const submitContactForm = createAsyncThunk(
    'form/submitContact',
    async (formData, { rejectWithValue }) => {
        try {
            const response = await formService.submitContactForm(formData)
            return response.data
        } catch (error) {
            return rejectWithValue(handleApiError(error))
        }
    }
)

export const submitEnquiryForm = createAsyncThunk(
    'form/submitEnquiry',
    async (formData, { rejectWithValue }) => {
        try {
            const response = await formService.submitEnquiryForm(formData)
            return response.data
        } catch (error) {
            return rejectWithValue(handleApiError(error))
        }
    }
)

export const subscribeNewsletter = createAsyncThunk(
    'form/subscribeNewsletter',
    async (formData, { rejectWithValue }) => {
        try {
            const response = await formService.subscribeNewsletter(formData)
            return response.data
        } catch (error) {
            return rejectWithValue(handleApiError(error))
        }
    }
)

export const submitCareerApplication = createAsyncThunk(
    'form/submitCareerApplication',
    async (formData, { rejectWithValue }) => {
        try {
            const response = await formService.submitCareerApplication(formData)
            return response.data
        } catch (error) {
            return rejectWithValue(handleApiError(error))
        }
    }
)

export const uploadResume = createAsyncThunk(
    'form/uploadResume',
    async (file, { rejectWithValue }) => {
        try {
            const response = await formService.uploadResume(file)
            return response.data
        } catch (error) {
            return rejectWithValue(handleApiError(error))
        }
    }
)

const formSlice = createSlice({
    name: 'form',
    initialState: {
        loading: false,
        error: null,
        success: false,
        lastSubmission: null
    },
    reducers: {
        clearFormState: (state) => {
            state.loading = false
            state.error = null
            state.success = false
            state.lastSubmission = null
        },
        clearError: (state) => {
            state.error = null
        }
    },
    extraReducers: (builder) => {
        // Generic handler for all form submissions
        const handleFormSubmission = (action) => {
            builder
                .addCase(action.pending, (state) => {
                    state.loading = true
                    state.error = null
                    state.success = false
                })
                .addCase(action.fulfilled, (state, action) => {
                    state.loading = false
                    state.success = true
                    state.lastSubmission = action.payload
                })
                .addCase(action.rejected, (state, action) => {
                    state.loading = false
                    state.error = action.payload
                    state.success = false
                })
        }

        // Apply to all form submission actions
        handleFormSubmission(submitContactForm)
        handleFormSubmission(submitEnquiryForm)
        handleFormSubmission(subscribeNewsletter)
        handleFormSubmission(submitCareerApplication)
        handleFormSubmission(uploadResume)
    }
})

export const { clearFormState, clearError } = formSlice.actions
export default formSlice.reducer